export const TOURNAMENT_MOBILE_BAR_HEIGHT = "3.5rem";
export const TOURNAMENT_MOBILE_CLEARANCE_VAR = "--tournament-mobile-clearance";

// Bottom nav only. The floating UP NEXT card is not shown on mobile.
export const tournamentMobileClearance = () =>
  `calc(${TOURNAMENT_MOBILE_BAR_HEIGHT} + 0.75rem + env(safe-area-inset-bottom, 0px))`;
